import type { MutableRefObject } from 'react';
import type { InternalListProps } from '../components/organisms/ListBase';
import { warnDeprecatedPropList } from '@/modules/InnerButton/utils/deprecation';

const ALTERNATIVE =
  'API agrupada (`list`, `selection`, `events`, `labels`, `search`, `profile`, `menu`, …)';

function pushIfOwn(props: object, key: string, into: string[]): void {
  if (Object.prototype.hasOwnProperty.call(props, key)) {
    into.push(key);
  }
}

/**
 * Props planas deprecadas presentes en `props` según `variant`.
 */
export function collectDeprecatedListBaseFlatKeys(props: InternalListProps): string[] {
  const used: string[] = [];
  const p = props as Record<string, unknown>;

  switch (props.variant) {
    case 'search-multi-checkbox':
      pushIfOwn(p, 'showSearch', used);
      pushIfOwn(p, 'searchPlaceholder', used);
      pushIfOwn(p, 'onHeaderCheckboxChange', used);
      pushIfOwn(p, 'onItemCheckboxChange', used);
      pushIfOwn(p, 'header', used);
      pushIfOwn(p, 'items', used);
      break;
    case 'default':
      pushIfOwn(p, 'items', used);
      pushIfOwn(p, 'currentValue', used);
      pushIfOwn(p, 'onItemClick', used);
      break;
    case 'separator':
      pushIfOwn(p, 'groups', used);
      pushIfOwn(p, 'currentValue', used);
      pushIfOwn(p, 'onItemClick', used);
      break;
    case 'radio':
      pushIfOwn(p, 'items', used);
      pushIfOwn(p, 'selectedValue', used);
      pushIfOwn(p, 'onSelectionChange', used);
      break;
    case 'users-select':
      pushIfOwn(p, 'users', used);
      pushIfOwn(p, 'searchPlaceholder', used);
      pushIfOwn(p, 'deleteButtonLabel', used);
      pushIfOwn(p, 'onUserToggle', used);
      pushIfOwn(p, 'onDelete', used);
      break;
    case 'toggle':
      pushIfOwn(p, 'items', used);
      pushIfOwn(p, 'onToggleChange', used);
      pushIfOwn(p, 'onItemsReorder', used);
      pushIfOwn(p, 'enableReordering', used);
      break;
    case 'user-list':
      pushIfOwn(p, 'users', used);
      pushIfOwn(p, 'selectedUserId', used);
      pushIfOwn(p, 'onUserClick', used);
      break;
    case 'checkbox':
      pushIfOwn(p, 'items', used);
      pushIfOwn(p, 'onCheckboxChange', used);
      break;
    case 'user-profile':
      pushIfOwn(p, 'user', used);
      pushIfOwn(p, 'menuItems', used);
      pushIfOwn(p, 'selectedItemId', used);
      pushIfOwn(p, 'darkMode', used);
      pushIfOwn(p, 'onMenuItemClick', used);
      pushIfOwn(p, 'onDarkModeToggle', used);
      break;
    case 'alphabetic':
      pushIfOwn(p, 'groups', used);
      pushIfOwn(p, 'selectedItem', used);
      pushIfOwn(p, 'onItemClick', used);
      break;
    case 'filters':
      pushIfOwn(p, 'items', used);
      pushIfOwn(p, 'title', used);
      pushIfOwn(p, 'selectedItemId', used);
      pushIfOwn(p, 'onItemClick', used);
      break;
    case 'filters-checkbox':
      pushIfOwn(p, 'items', used);
      pushIfOwn(p, 'title', used);
      pushIfOwn(p, 'clearLabel', used);
      pushIfOwn(p, 'applyLabel', used);
      pushIfOwn(p, 'onItemToggle', used);
      pushIfOwn(p, 'onClear', used);
      pushIfOwn(p, 'onApply', used);
      pushIfOwn(p, 'onBack', used);
      break;
    case 'empty':
      pushIfOwn(p, 'title', used);
      pushIfOwn(p, 'description', used);
      pushIfOwn(p, 'icon', used);
      break;
    default:
      break;
  }

  return used;
}

export function warnDeprecatedListBaseFlatPropsIfNeeded(
  props: InternalListProps,
  lastSignatureRef: MutableRefObject<string>
): void {
  if (process.env.NODE_ENV === 'production') {
    return;
  }
  const used = collectDeprecatedListBaseFlatKeys(props);
  if (used.length === 0) {
    return;
  }
  const sig = `${props.variant}:${used.slice().sort().join(',')}`;
  if (lastSignatureRef.current === sig) {
    return;
  }
  lastSignatureRef.current = sig;
  warnDeprecatedPropList(used, ALTERNATIVE, '[ListBase]');
}
